import { render, staticRenderFns } from "./AdherenceCategoryLookback.vue?vue&type=template&id=37563d23&"
import script from "./AdherenceCategoryLookback.vue?vue&type=script&lang=js&"
export * from "./AdherenceCategoryLookback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports